import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  artwork: z.string().optional().catch(undefined),
  cancelled: z.literal('1').optional().catch(undefined),
});

export const Route = createFileRoute('/passport/order/$orderId')({
  validateSearch: (search: Record<string, unknown>) => searchSchema.parse(search),
});
